import { render, staticRenderFns } from "./CustomerVisitReservation.vue?vue&type=template&id=32dfefe3"
import script from "./CustomerVisitReservation.vue?vue&type=script&lang=js"
export * from "./CustomerVisitReservation.vue?vue&type=script&lang=js"
import style0 from "./CustomerVisitReservation.vue?vue&type=style&index=0&id=32dfefe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports